import * as constants from 'Constants';

export const getMediaUrl = (rawUrl) => {
    if (!rawUrl) return '';
    try {
        const { pathname } = new URL(rawUrl, window.location.origin);
        return `${constants.base_url.replace(/\/$/, '')}${pathname}`;
    } catch (err) {
        return rawUrl;
    }
};
